import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-stats-card',
  templateUrl: './stats-card.component.html',
  styleUrls: ['./stats-card.component.scss']
})
export class StatsCardComponent {
  @Input() title: string = '';
  @Input() unit: string = '';
  @Input() YTDvalue: string | null = '';
  @Input() MTDvalue: string | null = '';
  @Input() icon: string = '';
  @Input() iconClass: string = 'text-primary bg-primary-subtle';

}
